// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewMenus_root__aWqw6","link":"ViewMenus_link__PzOSn","linkActive":"ViewMenus_linkActive__CEGES"};